import api from "../../../config/axios/configAxios";
import i18next from "i18next";
import { ShortLangToEnum } from "../../../features/common/converters/language";

export const getReports = async () =>
    api.get(`/api/Admin/Reports?langId=${ShortLangToEnum(i18next.language)}`);

export const getReportInfo = async(id: number) =>
    api.get(`/api/Admin/Reports/`+id+`/info?langId=${ShortLangToEnum(i18next.language)}`);

    export const GetReportFile = async (name: string, reportId: number, query: string) => {
        var res = await api.get("/api/Admin/Reports/"+reportId+"?"+query, {responseType: 'blob', }
        ).then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', name+'.xlsx');
          document.body.appendChild(link);
          link.click();
        }).catch(err => {
          throw err;
        })
      };